import { ProductState } from './product.types'

export const state: ProductState = {
  images: [],
  imagesLoadingError: null,
  sizes: [],
  sizesLoadingError: null,
  variants: [],
  variantsLoadingError: null,
  variantDeleteError: null,
  singleItem: null,
  variantUpdateError: null,
  createVariantError: null,
  queryObject: { limit: 20, skip: 0, filters: { canceled: false } },
  variantsFilter: 'All'
}
